/** @jsx jsx */
import { Fragment } from 'react';

import { jsx, css } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import { Animation, Colors } from '@zapier/design-system';

import { useVersionPromotion } from 'app/developer-v3/hooks';

import Start from './Start';
import Progress from './Progress';
import Title from '../Title';

import type { Props as SubsectionProps } from '../Subsection';

const Styles = {
  headerWrapper: css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    &&&&&& > h2 {
      margin: 0;
    }
  `,
  closeButton: css`
    display: block;
    background: transparent;
    border: none;
    color: ${Colors.GrayWarm6};
    transition: ${Animation.transitionValue};

    &:hover,
    &:focus {
      color: ${Colors.UiPrimaryStrongest};
      outline: 2px solid ${Colors.UiPrimaryStrongest};
      border-radius: 3px;
    }
  `,
};

type Props = Omit<SubsectionProps, 'sectionId'>;

function Promote({ integrationId, sectionContext, onClose }: Props) {
  const { isLoading, isPromoting, job, promote } = useVersionPromotion(
    integrationId
  );

  return (
    <Fragment>
      <div css={Styles.headerWrapper}>
        <Title>{`Promote version ${sectionContext.version}`}</Title>
        <button
          aria-label="Close modal"
          css={Styles.closeButton}
          onClick={onClose}
          type="button"
        >
          <Icon isBlock={true} name="formX" size={32} />
        </button>
      </div>
      {isPromoting ? (
        <Progress
          currentStep={job.currentStep}
          progress={job.progress}
          stage={job.stage}
        />
      ) : (
        <Start
          initialChangelog={sectionContext.changelog}
          isLoading={isLoading}
          onSubmit={promote}
          version={sectionContext.version}
        />
      )}
    </Fragment>
  );
}

export default Promote;
